<template>
  <div>
    <Breadcrumbs main="" title="购物车" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 empty-cart-cls text-center" v-if="!cart.length">
                  <img :src='getImgUrl("ecommerce/icon-empty-cart.png")' class="img-fluid mb-4">
                  <h3><strong>{{ $t("lbl_EMPBE_CartEmpty") }}</strong></h3>
                </div>
                <div class="order-history table-responsive wishlist" v-if="cart.length">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>{{ $t("lbl_EMPBE_Product") }}</th>
                        <th>{{ $t("lbl_EMPBE_Price") }}</th>
                        <th>{{ $t("lbl_EMPBE_ExpiryDate") }}</th>
                        <th>{{ $t("lbl_EMPBE_Quantity") }}</th>
                        <th>{{ $t("lbl_EMPBE_Action") }}</th>
                        <th>{{ $t("lbl_EMPBE_Total") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in cart" :key="index">
                        <td>
                          <div class="product-name">{{ langid == '1252' ? item.titleEn : langid == '950' ? item.titleTc :
                            item.titleSc }}</div>
                        </td>
                        <td>USD${{ item.priceUSD }} / RMB¥{{ item.priceRMB }}</td>
                        <td>2024/7/25</td>
                        <td>
                          <fieldset class="qty-box m-auto p-0">
                            <div class="input-group addToCart">
                              <i class="fa fa-minus btnGtr1" v-on:click="decrement(item)"></i>
                              <input class="touchspin text-center" v-model="item.quantity" name="item.quantity"
                                type="text">
                              <i class="fa fa-plus btnLess1" v-on:click="increment(item)"></i>
                            </div>
                          </fieldset>
                        </td>
                        <td><a href="javascript:void(0)" @click='removeProduct(item)'>
                            <feather type="x-circle"></feather>
                          </a></td>
                        <td>USD${{ item.priceUSD * item.quantity }} / RMB¥{{ item.priceRMB * item.quantity }}</td>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <div class="input-group">
                            <!-- <input class="form-control mr-2" type="text" placeholder="Enter coupan code"><a class="btn btn-primary" href="#">Apply</a> -->
                          </div>
                        </td>
                        <td class="total-amount">
                          <h6 class="m-0 text-right"><span class="f-w-600">{{$t("lbl_EMPBE_TotalCost")}} :</span></h6>
                        </td>
                        <td><span>USD${{ getAmountUSD }} / RMB¥{{ getAmountRMB }} </span></td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Container-fluid Ends-->
          </div>
          <div class="card" v-if="cart.length">
            <div class="card-body">
              <div class="row">
                <div class="panel-body" id="OnlinePay">
                  <div>
                    <table class="table table-bordered" style="width:100%">
                      <tbody>
                        <tr>
                          <td colspan="2" align="center">
                            <span id="lblPay">
                              {{ $t("lbl_EMPBE_OnlinePaymentTitle") }}
                            </span>
                            <span id="lblpay">
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td align="center">
                            <div class="radio3 radio-check radio-success radio-inline">
                              <input type="radio" id="chkUsd" name="ChkPay" value="USD" v-model="chkPayment">
                              <label for="chkUsd" style="font-size:18px;padding-top:4px">
                                <strong style="color:red"> {{ $t("lbl_EMPBE_USD") }} <span id="totalUsd">USD${{
                                  getAmountUSD }}</span></strong>
                              </label>
                            </div>
                          </td>
                          <td align="center">
                            <div class="radio3 radio-check radio-success radio-inline">
                              <input type="radio" id="chkRmb" name="ChkPay" value="RMB" v-model="chkPayment" checked>
                              <label for="chkRmb" style="font-size:18px;padding-top:4px">
                                <strong style="color:red"> {{ $t("lbl_EMPBE_RMB") }} <span id="totalRmb">RMB¥{{
                                  getAmountRMB }}</span></strong>
                              </label>
                            </div>

                          </td>
                        </tr>
                        <tr>
                          <td align="center" width="50%">
                            <img style="vertical-align:middle" alt=""
                              src="https://eform.adsaleinfo.com/temp_files/CPS23/logo_paypal.png" border="0">
                            <img style="vertical-align:middle" alt=""
                              src="https://eform.adsaleinfo.com/temp_files/CPS23/logo_visa.jpg" border="0">
                            <img style="vertical-align:middle" alt=""
                              src="https://eform.adsaleinfo.com/temp_files/CPS23/logo_master.jpg" border="0">
                          </td>
                          <td align="center" width="50%">
                            <img style="vertical-align:middle" alt=""
                              src="https://eform.adsaleinfo.com/temp_files/CPS23/logo_alipay.jpg" border="0">
                            <img style="vertical-align:middle" alt=""
                              src="https://eform.adsaleinfo.com/temp_files/CPS23/logo_wechat.jpg" border="0">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div id="lblFreePermitSchemePay" style="width: 100%; margin-top: 10px;"
                      v-html="$t('lbl_EMPBE_OnlinePaymentTerms')">
                    </div>
                    <div id="paymention">
                      <p>
                      </p>
                      <div class="row">
                        <div class="col-sm-3">
                          <textbox :title="$t('lbl_EMPBE_PaymentEmail')" type="email" ref="paymentEmail"
                            v-model="paymentEmail" :mandatory="$t('lbl_EMPBE_PleaseInputEmail')">
                          </textbox>
                        </div>
                        <div
                          class="col-sm-6 checkbox3 checkbox-success checkbox-inline checkbox-check checkbox-round  checkbox-light">
                          <input v-model="cbFormPayment" type="checkbox" id="cbFormPayment" name="cbFormPayment">
                          <label style="padding:8px 0 8px 30px" for="cbFormPayment">
                            <strong>{{ $t("lbl_EMPBE_AgreeTerms") }}</strong>
                          </label>
                        </div>

                      </div>
                      <p></p>
                      <div>
                        <button @click="paymentgo" :disabled="isDisableFormPayment" id="btnPaymentgo" type="button"
                          class="btn btn-primary" v-bind:t_label="'EMPBE_Cart_btnPay'">{{ $t("lbl_EMPBE_PayAndConfirm") }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Container-fluid Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
    <!-- hidden payment form Starts-->
    <RMBPopup ref="RMBPopup" :email="paymentEmail"></RMBPopup>
    <USDPopup id="USDPopup" ref="USDPopup" :email="paymentEmail"></USDPopup>
    <!-- hidden payment form Ends -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import RMBPopup from './RMBPopup.vue';
import USDPopup from './USDPopup.vue';

export default {
  name: 'Product',
  components: {
    RMBPopup,
    USDPopup
  },
  data() {
    return {
      counter: 1,
      chkPayment: 'RMB',
      cbFormPayment: false,
      paymentEmail: "",
    };
  },
  mounted() {
    this.cart_close();
  },
  computed: {
    ...mapState({
      cart: state => state.paymentItem.cart,
      getAmountUSD() {
        return this.totalAmount = this.$store.getters['paymentItem/getTotalAmount_USD'];
      },
      getAmountRMB() {
        return this.totalAmount = this.$store.getters['paymentItem/getTotalAmount_RMB'];
      },
      isDisableFormPayment() {
        return !this.cbFormPayment || this.$refs.paymentEmail.isinvalid;
      },
      langid() {
        return localStorage.getItem("currentLangId")
      }
    })
  },
  methods: {
    cart_close() {
      this.$store.dispatch("paymentItem/toggleCart", false);
    },
    getImgUrl(path) {
      return require('../../assets/images/' + path);
    },
    removeProduct: function (product) {
      this.$store.dispatch('paymentItem/removeProduct', product);
    },
    increment(product, qty = 1) {
      this.$store.dispatch('paymentItem/updateCartQuantity', { 'product': product, 'qty': qty });
    },
    decrement(product, qty = -1) {
      this.$store.dispatch('paymentItem/updateCartQuantity', { 'product': product, 'qty': qty });
    },
    paymentgo() {
      switch (this.chkPayment) {
        case "RMB":
          this.$refs.RMBPopup.popup();
          break;
        case "USD":
          this.$refs.USDPopup.popup();
          break;
      }
    }
  }
};
</script>